import classNames from "classnames";
import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { DocumentCategoryRow } from "../utils";
import styles from "../children/DocumentCategoryItem.module.scss";

export const PercentageCell = memo(function PercentageCell({
    row,
}: CellContext<ViewTableFeatures, DocumentCategoryRow, unknown>) {
    const { percentage } = row.original;

    if (isNaN(percentage)) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell>
            <span
                className={classNames(styles.label, {
                    [styles.zero]: percentage === 0,
                })}
            >
                {percentage.toFixed(1)}%
            </span>
        </ViewTableCell>
    );
});
